module.exports = __webpack_public_path__ + "img/ic-contact-line.f9b6b70c.png";